import styled from 'styled-components';
import { spacing, colors, smallShadow, heading5, fontWeights } from 'ui/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.plusHalf};
  border-radius: ${spacing.half};
  background-color: ${colors.backgroundPrimary};
  gap: ${spacing.threeQuarter};
  ${smallShadow};
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  grid-template-areas: 'heading right' 'description right';
  gap: ${spacing.half};
`;

export const Heading = styled.h5`
  ${heading5};
  font-weight: ${fontWeights.bold};
  grid-area: heading;
  margin-bottom: 0;
`;

export const Description = styled.div`
  grid-area: description;
`;

export const Right = styled.div`
  grid-area: right;
`;

export const HeadingWithMetrics = styled(Heading)`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
